import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children }) => (
  <div className="flex items-center gap-3 font-mono2 text-[11px] tracking-[0.25em] uppercase text-teal-300/90">
    <span className="h-px w-8 grad-line" />
    {children}
  </div>
);
